import { executeApiCall } from 'services/api';
import { getMutations } from 'entities/hooks/mutation';
import { QuotationRequest } from '../types';

type CreateQuotationRequestParams = Pick<
  QuotationRequest,
  'client' | 'value' | 'currency' | 'country' | 'comment' | 'project'
>;

type AnswerQuotationRequestParams = {
  project: string;
  request: string;
  value: string;
  comment: string;
};

export const quotationRequestMutations = getMutations({
  createQuotationRequest: {
    action: async (payload: CreateQuotationRequestParams): Promise<QuotationRequest> => {
      return executeApiCall({
        path: '/invoice/projects/quotation-requests',

        method: 'post',

        payload,
      });
    },
  },

  answerQuotationRequest: {
    action: async (payload: AnswerQuotationRequestParams): Promise<QuotationRequest> => {
      return executeApiCall({
        path: 'invoice/projects/quotation-requests',

        method: 'put',

        payload,
      });
    },

    messages: {
      error: (t) => t('error-while-saving-quotation')!,

      success: (t) => t('quotation-sent')!,
    },
  },
});
